var JD = {};

JD.debounce = function(func, wait, immediate) {
  console.log("timeout");
    var timeout;
    return function() {
        var context = this,
            args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait || 125);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

/* swap logos on scroll */
$(window).scroll(function() {
   if ($(this).scrollTop() > 100){
      $('#university-logo').removeClass('logo-1-background').removeClass('logo-1').addClass('logo-2');
   } else if ($(this).scrollTop() < 50){
      $('#university-logo').removeClass('logo-2').addClass('logo-1-background').addClass('logo-1');
   }
});

$(document).ready(function() {
  ($(document).foundation())
});
